import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import logoSm from "../assets/images/logo_sm.png";
import logoDarkSm from "../assets/images/logo_sm_dark.png";
import AppMenu from "./Menu/";
import classNames from "classnames";
import feedback from "../assets/images/feedback.svg";
import packageJson from "../../package.json";
import { FeedbackLink } from "constants/links";
import { useRedirect } from "pages/login/Login";

type LeftSidebarProps = {
    hideLogo?: boolean;
    hideUserProfile: boolean;
    isLight: boolean;
    isCondensed: boolean;
    menuItems: any;
    toggleMenu: () => void;
};

const LeftSidebar = ({ isCondensed, isLight, hideLogo, hideUserProfile, menuItems, toggleMenu }: LeftSidebarProps) => {
    const menuNodeRef = useRef<HTMLDivElement>(null);

    /**
     * Handle the click anywhere in doc
     */
    const handleOtherClick = (e: MouseEvent) => {
        if (menuNodeRef && menuNodeRef.current && menuNodeRef.current.contains(e.target as Node)) return;
        // else hide the menubar
        if (document.body) {
            document.body.classList.remove("sidebar-enable");
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOtherClick, false);
        return () => {
            document.removeEventListener("mousedown", handleOtherClick, false);
        };
    }, []);

    return (
        <div className="leftside-menu" ref={menuNodeRef}>
            <div className="logo text-center logo-light">
                <span className="logo-lg">
                    <img src={logo} alt="logo" height="23" />
                </span>
                <span className="logo-sm">
                    <img src={isLight ? logoSm : logoDarkSm} alt="logo" height="25" />
                </span>
            </div>
            <>
                <AppMenu menuItems={menuItems} />
                <div className="clearfix" />
                <p className="zf-version">v{packageJson.version}</p>
            </>
        </div>
    );
};

export default LeftSidebar;
